import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from '../../../services/notification.service';
import { FormularioService } from '../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators, ValidatorFn } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ActionMessage, TypeMessage } from 'src/app/entity/enum/enum-notification';
import { DropDownListDTO, DropDownListSiteRecebimentoDTO } from 'src/app/entity/dto/dropdownlist.component';
import { Observable } from 'rxjs';
import { map, startWith, take } from 'rxjs/operators';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs005-card-V',
    templateUrl: './rs005-card-V.component.html'
})

export class Rs005CardVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public listLimpezaManual?: Array<DropDownListSiteRecebimentoDTO> = new Array<DropDownListSiteRecebimentoDTO>();

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Perda na Despalha', false);
        if (this.isBasica || this.isComercial) {
            this.formulario = this.formBuilder.group({
                Perda_espigas_inteiras: [null, []],
                Perda_graos_debulhados_despalha: [null, []],
                Perda_total_despalha: [null, []],
            });

            this.formulario.get('Perda_total_despalha')['warning'] = true;
        }
        else if (this.isPreBasica) {
            this.formulario = this.formBuilder.group({
                limpeza_manual: [null, [Validators.required]],
                inicio_limpeza_manual_data: [null, [Validators.pattern(this.regexDate)]],
                inicio_limpeza_manual_hora: [null, [Validators.pattern(this.regexHour)]],
                fim_limpeza_manual_data: [null, [Validators.pattern(this.regexDate)]],
                fim_limpeza_manual_hora: [null, [Validators.pattern(this.regexHour)]],
            });
            this.step = 'ETAPA 4 (Limpeza manual)'
        }


    }

    async ngOnInit(): Promise<void> {
        await Promise.all([this.getListLimpezaManual()]);
    }

    public changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    warningValidatorPerdaTotal(): boolean {
        const perdaTotal = this.formulario.get('Perda_total_despalha').value;
        return perdaTotal > 0 && perdaTotal < 100;

    }

    async getListLimpezaManual(): Promise<void> {
        const site: string = this.generalService.getLocalStorageDataSite();
        await this.formularioService
            .getListDropDownList('rs005', 'limpeza_manual')
            .pipe(take(1))
            .toPromise()
            .then((response) => {
                if (!!response?.data) {
                    this.listLimpezaManual = this.generalService.orderByDropDownList(
                        response.data as DropDownListDTO[]
                    )
                }
            })
            .catch(async (error: HttpErrorResponse) => {
                this.notificationService.showNotificationError(
                    error,
                    '',
                    TypeMessage.ListErrorSafra
                );
            });
    }

    validDates($event) {
        if (this.formulario?.get('inicio_limpeza_manual_data').value &&
            this.formulario?.get('inicio_limpeza_manual_hora').value &&
            this.formulario?.get('fim_limpeza_manual_data').value &&
            this.formulario?.get('fim_limpeza_manual_hora').value) {
            var dateInit = this.generalService.createDateTimeData(this.formulario?.get('inicio_limpeza_manual_data').value, this.formulario?.get('inicio_limpeza_manual_hora').value);
            var dateEnd = this.generalService.createDateTimeData(this.formulario?.get('fim_limpeza_manual_data').value, this.formulario?.get('fim_limpeza_manual_hora').value);

            if (dateInit > dateEnd) {
                this.formulario?.get('fim_limpeza_manual_data').setErrors({ error: true });
                this.formulario?.get('fim_limpeza_manual_hora').setErrors({ error: true });
            }
            else {
                this.formulario?.get('fim_limpeza_manual_data').setErrors(null);
                this.formulario?.get('fim_limpeza_manual_hora').setErrors(null);
            }
        }
    }

}